import TrustdPhoneLookup from "./TrustdPhoneLookup";
import TrustdLinkedinSearch from "./TrustdLinkedinSearch";
import {
  recordsForWatchlistSource,
  normalizeLegacyEndatoResult,
  resolveOverallScreeningStatus,
  SCREENING_DESCRIPTIONS,
  SCREENING_STATUS,
} from "../utils/BackgroundScreening";

export default class TrustdResponse {

  constructor() {
    this.trustdReference = null;
    this.guestId = null;
    this.score = null;
    this.score_numeric = null;
    this.scoreImage = null;
    this.criminalList = null;
    this.criminalListRecords = null;
    this.criminalListDescription = null;
    this.arrestList = null;
    this.arrestListRecords = null;
    this.wantedList = null;
    this.wantedListRecords = null;
    this.sexOffenderList = null;
    this.sexOffenderListRecords = null;
    this.sexOffenderListDescription = null;
    this.ofacList = null;
    this.ofacListRecords = null;
    this.ofacListDescription = null;
    this.unList = null;
    this.unListRecords = null;
    this.unListDescription = null;
    this.fbiList = null;
    this.fbiListRecords = null;
    this.fbiListDescription = null;
    this.screeningResult = null;
    this.watchList = null;
    this.watchListRecords = null;
    this.isSuspiciousIp = null;
    this.linkedinSearch = null;
    this.phoneLookup = null;
  }

  static create(rawData, payload = null) {
    let data = JSON.parse(JSON.stringify(rawData));
    console.log('data', data);

    const response = new TrustdResponse();
    response.trustdReference = data.trustd_reference;
    response.guestId = data.guest_id;
    response.score = data.score;
    response.score_numeric = data.score_numeric;
    response.scoreImage = data.score_image;
    response.criminalList = normalizeLegacyEndatoResult({
      status: data.criminal_list,
      records: data.criminal_lists_record,
      payload,
    });
    response.criminalListRecords = data.criminal_lists_record;
    response.criminalListDescription = data.criminal_list_description || (
      response.criminalList === SCREENING_STATUS.POTENTIAL_MATCH
        ? SCREENING_DESCRIPTIONS.CONVICTION_POTENTIAL_MATCH
        : response.criminalList === SCREENING_STATUS.SOFT_MATCH
          ? SCREENING_DESCRIPTIONS.SOFT_MATCH
          : null
    );
    response.arrestList = data.arrest_list;
    response.arrestListRecords = data.arrest_lists_record;
    response.wantedList = data.wanted_list;
    response.wantedListRecords = data.wanted_lists_record;
    response.sexOffenderList = normalizeLegacyEndatoResult({
      status: data.sex_offender_list,
      records: data.sex_offender_lists_record,
      payload,
    });
    response.sexOffenderListRecords = data.sex_offender_lists_record;
    response.sexOffenderListDescription = data.sex_offender_list_description || (
      response.sexOffenderList === SCREENING_STATUS.POTENTIAL_MATCH
        ? SCREENING_DESCRIPTIONS.CONVICTION_POTENTIAL_MATCH
        : response.sexOffenderList === SCREENING_STATUS.SOFT_MATCH
          ? SCREENING_DESCRIPTIONS.SOFT_MATCH
          : null
    );
    response.watchList = data.watch_list;
    response.watchListRecords = data.watch_lists_record;
    const ofacLegacyRecords = recordsForWatchlistSource(data.watch_lists_record, "ofac_sdn");
    const unLegacyRecords = recordsForWatchlistSource(data.watch_lists_record, "un_consolidated");
    const fbiLegacyRecords = recordsForWatchlistSource(data.watch_lists_record, "fbi_wanted");
    response.ofacList = data.ofac_list || (ofacLegacyRecords.length > 0 ? SCREENING_STATUS.POTENTIAL_MATCH : SCREENING_STATUS.CLEAR);
    response.ofacListRecords = data.ofac_lists_record || (ofacLegacyRecords.length > 0 ? ofacLegacyRecords : SCREENING_STATUS.CLEAR);
    response.ofacListDescription = data.ofac_list_description || (ofacLegacyRecords.length > 0 ? SCREENING_DESCRIPTIONS.OFAC_POTENTIAL_MATCH : null);
    response.unList = data.un_list || (unLegacyRecords.length > 0 ? SCREENING_STATUS.POTENTIAL_MATCH : SCREENING_STATUS.CLEAR);
    response.unListRecords = data.un_lists_record || (unLegacyRecords.length > 0 ? unLegacyRecords : SCREENING_STATUS.CLEAR);
    response.unListDescription = data.un_list_description || (unLegacyRecords.length > 0 ? SCREENING_DESCRIPTIONS.UN_POTENTIAL_MATCH : null);
    response.fbiList = data.fbi_list || (fbiLegacyRecords.length > 0 ? SCREENING_STATUS.POTENTIAL_MATCH : SCREENING_STATUS.CLEAR);
    response.fbiListRecords = data.fbi_lists_record || (fbiLegacyRecords.length > 0 ? fbiLegacyRecords : SCREENING_STATUS.CLEAR);
    response.fbiListDescription = data.fbi_list_description || null;
    response.screeningResult = resolveOverallScreeningStatus({
      ...response,
      screeningResult: data.screening_result,
    });
    response.isSuspiciousIp = data.is_anonymous_ip;
    response.linkedinMatches = data.linkedin_matches;
    if (data.linkedin_search != null) {
      response.linkedinSearch = TrustdLinkedinSearch.create(data.linkedin_search);
    }

    if (data.phone_lookup != null) {
      response.phoneLookup = TrustdPhoneLookup.create(data.phone_lookup);
    }

    if(data.score === 'AVERAGE TRUST') {
      response.score = 'GOOD';
    }

    return response;
  }

}
